import React, { useEffect, useState } from "react";
import ContactUs from "../../Components/Popup/ContactUs";
import { Link, useParams } from "react-router-dom";
import imagePath from "../../constants/imagePath";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import { CircleCheck } from "../../constants/svgPath";
import { industriesData } from "./industeriesDetailsData";

function IndustriesDetails() {
  const { slug } = useParams();
  const pageData = industriesData[slug ?? "finance"];
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectTechStackItem, setSelectTechStackItem] = useState(
    pageData.stackItems.data[0],
  );
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const activeService = pageData.services.data[activeIndex];

  const handleClick = (index: number) => {
    setActiveIndex(index);
  };
  useEffect(() => {
    const body = document.body;

    if (isPopupOpen) {
      body.classList.add("body_active");
    } else {
      body.classList.remove("body_active");
    }

    // Cleanup (optional)
    return () => body.classList.remove("body_active");
  }, [isPopupOpen]);

  return (
    <>
      <section className="aboutbg services_sec services_sec_layered">
        {/* Bottom layer: actual content image */}
        {pageData?.banner?.backgroundImage && (
          <div
            className="services_sec_content_bg"
            style={{
              backgroundImage: `url(${pageData.banner.backgroundImage})`,
            }}
            aria-hidden
          />
        )}
        {/* Overlay: black film / overlay image for text readability */}
        <div
          className="services_sec_overlay_bg"
          style={{
            backgroundImage: `url(${imagePath.top_overlay})`,
          }}
          aria-hidden
        />
        <div className="contair services_sec_content">
          <div className="banner_left">
            {/* <div className="bread">
              <Link to="/">Home </Link>
              <Link to="/news-insights"> / Industries </Link>{" "}
              <span>/ {pageData?.title} </span>
            </div> */}

            <h1>
              {pageData?.banner.title}{" "}
              <span className="blk"> {pageData?.banner?.highlight}</span>
            </h1>
            <p className="banner_txt">{pageData?.banner?.description}</p>
            <button
              type="button"
              onClick={() => setIsPopupOpen(true)}
              className="btn_common btn_primry"
            >
              {pageData?.banner?.cta}
            </button>
          </div>
        </div>
      </section>
      <section className="logis_sec common_padd">
        <div className="contair">
          <div className="next_heading">
            <h2>{pageData.services.title}</h2>
            <p>{pageData.services.description}</p>
          </div>
          <div className="logis_flx">
            <div className="logis_l">
              <ul className="logis_list">
                {pageData.services.data.map((service, index) => (
                  <li
                    key={index}
                    className={`logis_pt ${activeIndex === index ? "active" : ""}`}
                    onClick={() => handleClick(index)}
                  >
                    <span>{service.number}</span>
                    <h3>{service.title}</h3>
                  </li>
                ))}
              </ul>
            </div>
            <div className="logis_r">
              <figure>
                <img src={activeService.image} alt={activeService.title} />
                <figcaption></figcaption>
              </figure>

              <h3>{activeService.subtitle}</h3>
              <p>{activeService.description}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="tail_sec common_padd">
        <div className="contair">
          <div className="next_heading">
            <h2>{pageData.stackItems.title}</h2>
            <p>{pageData.stackItems.description}</p>
          </div>
          <ul className="stack_list">
            <Swiper
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              navigation={false}
              pagination={false}
              keyboard={true}
              slidesPerView="auto"
              freeMode={true}
              grabCursor={true}
              className="mySwiper1"
            >
              {pageData.stackItems.data.map((item, index) => (
                <SwiperSlide
                  style={{ width: "auto" }}
                  className={`stack_link ${selectTechStackItem.title == item.title ? "stack_slt" : ""}`}
                  onClick={() => setSelectTechStackItem(item)}
                >
                  <Link to="" className="stack_hrf">
                    {item.title}
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </ul>
          <div className="tail_btm">
            <figure>
              <img src={selectTechStackItem.image} alt="" />
            </figure>
            <div className="tail_bx">
              <ul className="tail_lst">
                {selectTechStackItem.points.map((item) => (
                  <li className="tail_pt">
                    <CircleCheck /> <span> {item}</span>
                  </li>
                ))}
              </ul>
              <div className="btn_center">
                <button
                  type="button"
                  onClick={() => setIsPopupOpen(true)}
                  className="btn_common btn_primry"
                >
                  Let’s Connect!
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hire_sec common_padd img_stle">
        <div className="contair">
          <div className="hire_mn">
            <div className="heading txt_l">
              <h2>{pageData.readyToHire.title}</h2>
            </div>
            <div className="client_btn">
              <button
                type="button"
                onClick={() => setIsPopupOpen(true)}
                className="btn_common btn_primry"
              >
                {pageData.readyToHire.cta}
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="partner_sec common_padd">
        <div className="contair partner_mn">
          <figure className="partner_img">
            <img src={imagePath.Partner} alt="" />
          </figure>
          <div className="partner_r">
            <div className="heading txt_l">
              <h2>{pageData.partnerReasons.title}</h2>
              <p>{pageData.partnerReasons.description}</p>
            </div>

            <ul className="partner_list">
              {pageData.partnerReasons.data.map((item) => (
                <li className="partner_bx">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </li>
              ))}
            </ul>
            <div className="client_btn">
              <button
                type="button"
                onClick={() => setIsPopupOpen(true)}
                className="btn_common btn_primry"
              >
                Consult Our Experts!
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="soft_sec common_padd">
        <div className="contair">
          <div className="heading">
            <h2>{pageData.process.title}</h2>
            <p>{pageData.process.description}</p>
          </div>

          <ul className="soft_lst">
            {pageData.process.data.map((item) => (
              <li className="our_bx common_border">
                <h3>{item?.title}</h3>
                <p>{item?.description}</p>
                <figure className="mng_img">
                  <img src={item.image} alt="" />
                </figure>
              </li>
            ))}
          </ul>
          <div className=""></div>
        </div>
      </section>
      <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default IndustriesDetails;
